import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ChatIcon, ChatIconOutline, DotDotDotVerticalIcon, } from '@streamr/tv-ui';
import { useRef } from 'react';
import styled from 'styled-components';
import pkg from '../../../package.json';
import { BroadcastStateService } from '../../services/broadcaststate/BroadcastStateService';
import { MediaService } from '../../services/media/MediaService';
import { Anchor } from '../Anchor';
import { AudioDeviceButton, VideoDeviceButton } from '../DeviceButton';
import { showBroadcastPopup } from '../popups/BroadcastPopup';
import { selectCamera } from '../popups/devices/CameraSelectorPopup';
import { selectMicrophone } from '../popups/devices/MicrophoneSelectorPopup';
import { RecordingStatusIndicator } from './helpers/RecordingStatusIndicator';
import { ShareScreenButton } from './helpers/ShareScreenButton';
import { ToggleLiveButton } from './helpers/ToggleLiveButton';
export function BroadcasterFooter(props) {
    const { broadcastContext, onVideoQualityChanged, onSidebarClick, showSidebar, broadcastServiceIsRunning, isBroadcasting, onGoLiveClick, onEndBroadcastClick, } = props;
    const activeBroadcast = BroadcastStateService.getOutput().useRequiredActiveBroadcast();
    const mediaService = MediaService.getNotificationInterface();
    const mediaOutputMediaStreamData = MediaService.getOutput().useMediaStreamData();
    const mediaOutputAudioMuted = MediaService.getOutput().useAudioMuted();
    const mediaOutputVideoMuted = MediaService.getOutput().useVideoMuted();
    const connectedVideoDevices = MediaService.getOutput().useVideoDevices();
    const connectedAudioDevices = MediaService.getOutput().useAudioDevices();
    const settingsButtonAnchorRef = useRef(null);
    const onMuteAudioButtonClicked = () => {
        if (mediaOutputAudioMuted) {
            mediaService.notifyAudioMutingChangeRequested(false);
        }
        else {
            mediaService.notifyAudioMutingChangeRequested(true);
        }
    };
    const onMuteVideoButtonClicked = () => {
        if (mediaOutputVideoMuted) {
            mediaService.notifyVideoMutingChangeRequested(false);
        }
        else {
            mediaService.notifyVideoMutingChangeRequested(true);
        }
    };
    return (_jsxs(BroadcasterFooterRoot, { children: [_jsxs(LeftSide, { children: [_jsx(AudioDeviceButton, { devicePresent: connectedAudioDevices.length > 0, muted: mediaOutputAudioMuted ||
                            mediaOutputMediaStreamData.isSharingScreenAudio, onMuteClick: onMuteAudioButtonClicked, onSelectClick: (anchor) => {
                            selectMicrophone({
                                anchorRef: anchor,
                                variant: 'top-center',
                            });
                        } }), _jsx(VideoDeviceButton, { devicePresent: connectedVideoDevices.length > 0, muted: mediaOutputVideoMuted ||
                            mediaOutputMediaStreamData.isSharingScreenVideo, onMuteClick: onMuteVideoButtonClicked, onSelectClick: (anchor) => {
                            selectCamera({
                                anchorRef: anchor,
                                variant: 'top-center',
                            });
                        } }), _jsx(ShareScreenButtonWrap, { children: _jsx(ShareScreenButton, {}) }), _jsx(ToggleLiveButton, { device: "desktop", broadcastServiceIsRunning: broadcastServiceIsRunning, isBroadcasting: isBroadcasting, onGoLiveClick: onGoLiveClick, onEndBroadcastClick: onEndBroadcastClick }), _jsxs(VersionDisplay, { children: ["v", pkg.version] })] }), _jsxs(RightSide, { children: [_jsx(RecordingStatusIndicator, { broadcast: activeBroadcast }), _jsx(ChatButton, { title: "Chat", onClick: () => onSidebarClick(), children: showSidebar ? _jsx(ChatIcon, {}) : _jsx(ChatIconOutline, {}) }), _jsx(Anchor, { ref: settingsButtonAnchorRef, children: _jsx(BaseButton, { title: "Settings", onClick: () => {
                                showBroadcastPopup({
                                    broadcast: activeBroadcast,
                                    anchorRef: settingsButtonAnchorRef,
                                    variant: 'desktop',
                                    context: broadcastContext,
                                    onVideoQualityChanged,
                                });
                            }, children: _jsx(DotDotDotVerticalIcon, {}) }) })] })] }));
}
const ShareScreenButtonWrap = styled.div `
    display: var(--ShareScreenButton_Display, block);
`;
const LeftSide = styled.div `
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap-reverse;
    max-width: 60%;
    --ShareScreenButton_Display: none;
    

    @media (min-width: 48rem) {
        --ShareScreenButton_Display: initial;
    }
`;
const RightSide = styled.div `
    display: flex;
    align-items: center;
    gap: 1rem;
`;
const BroadcasterFooterRoot = styled.div `
    overflow: hidden;
    padding: 1.5rem;
    position: relative;

    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    @media (min-width: 48rem) {
        --Segment0_Display: none;
    }

    --DeviceButton_TopBackground: var(--tv-ui-color-4);
    --DeviceButton_UnderneathBackground: var(--tv-ui-color-21);
`;
const BaseButton = styled(Button) `
    --Button_Width: 3rem;
    --Button_Height: 3rem;
    color: var(--tv-ui-color-3);
`;
const ChatButton = styled(BaseButton) `
    display: none;
    @media (min-width: 60rem) {
        display: flex;
    }
`;
const VersionDisplay = styled.div `
    position: absolute;
    line-height: 1;
    inset: auto auto 0.5rem 0.5rem;
    color: rgba(255, 255, 255, 0.5);
    font-size: 0.625rem;
    font-weight: 500;
    letter-spacing: -0.02em;
`;
